import * as React from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';

import { cn } from '@/lib/utils';

const RadioGroup = React.forwardRef<
    React.ElementRef<typeof RadioGroupPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => (
    <RadioGroupPrimitive.Root
        ref={ref}
        className={cn('flex flex-col', className)}
        {...props}
    />
));
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = React.forwardRef<
    React.ElementRef<typeof RadioGroupPrimitive.Item>,
    React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => (
    <RadioGroupPrimitive.Item
        ref={ref}
        className={cn(
            'group relative size-5 shrink-0 flex-none p-0',
            'focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
            'disabled:cursor-not-allowed disabled:opacity-50',
            className,
        )}
        {...props}
    >
        <span
            className={cn(
                'absolute left-1/2 top-1/2 size-4 -translate-x-1/2 -translate-y-1/2 box-border',
                'border border-grey-500 rounded-[12px]',
                'group-data-[state=checked]:bg-grey-900 group-data-[state=checked]:border-grey-500',
            )}
        />
        <RadioGroupPrimitive.Indicator
            className={cn(
                'absolute left-1/2 top-1/2 size-2.5 -translate-x-1/2 -translate-y-1/2',
                'bg-white-100 rounded-[8px]',
                'opacity-0 group-data-[state=checked]:opacity-100',
            )}
        />
    </RadioGroupPrimitive.Item>
));
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
